import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertTriangle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 9,
			x2: 12,
			y2: 13
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 17,
			x2: 12.01,
			y2: 17
		})
	]
});
export default SvgAlertTriangle;
